import { formatLocalHm } from './clock';
import type { TownEvent } from './types';

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function dateKeyInZone(date: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const y = parts.find((p) => p.type === 'year')?.value;
  const m = parts.find((p) => p.type === 'month')?.value;
  const d = parts.find((p) => p.type === 'day')?.value;
  return `${y}-${m}-${d}`;
}

export function addDays(dateKey: string, days: number): string {
  const d = new Date(`${dateKey}T12:00:00`);
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function eventsInNextFiveDays(events: TownEvent[], today: string): TownEvent[] {
  const end = addDays(today, 4);
  return events
    .filter((e) => e.date >= today && e.date <= end)
    .sort((a, b) => a.date.localeCompare(b.date) || (a.startTime ?? '').localeCompare(b.startTime ?? ''));
}

export function formatEventDayLabel(dateKey: string, today: string): string {
  if (dateKey === today) return 'Today';
  if (dateKey === addDays(today, 1)) return 'Tomorrow';
  return new Date(`${dateKey}T12:00:00`).toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
}

export function formatEventTimeRange(event: TownEvent): string {
  if (!event.startTime) return '';
  const start = formatLocalHm(event.startTime);
  if (event.endTime) return `${start}–${formatLocalHm(event.endTime)}`;
  return start;
}

export function shortEventLocation(location: string): string {
  return location.split(',')[0]?.trim() ?? location;
}
